/* import __COLOCATED_TEMPLATE__ from './date-editor.hbs'; */
/* RESPONSIBLE TEAM: team-frontend-tech */
/* === ⚠️ THIS FILE CURRENTLY USES DEPRECATED PATTERNS ⚠️ === */
/* === 🔗 For more information visit https://go.inter.com/ember-best-practices 🔗 */
/* === 🚀 Please consider refactoring & removing some of the comments below when working on this file 🚀 */
/* eslint-disable @intercom/intercom/no-component-inheritance */
import { computed, action } from '@ember/object';
import { filter, filterBy } from '@ember/object/computed';
import BaseEditor from './base-editor';
export default BaseEditor.extend({
  noInputComparisonsOptions: filter('comparisonOptions', function (option) {
    return option.value.includes('known');
  }),
  relativeComparisonOptions: filterBy('comparisonOptions', 'type', 'relative'),
  absoluteComparisonOptions: filterBy('comparisonOptions', 'type', 'absolute'),
  selectedDate: computed('predicate.value.{day,month,year}', function () {
    return new Date(this.get('predicate.value.year'), this.get('predicate.value.month') - 1, this.get('predicate.value.day'));
  }),
  setAbsoluteValue: action(function (value) {
    let date = value.date;
    this.changePredicateValue({
      day: date.getDate(),
      month: date.getMonth() + 1,
      year: date.getFullYear()
    });
  })
});